/**
 * HeadSettings.jsx — CRUD de Heads no painel de admin.
 */

import React, { useEffect, useState } from "react";
import { fetchHeads, createHead, updateHead, deleteHead } from "../../services/api";

export default function HeadSettings() {
  const [lista, setLista]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [erro, setErro]         = useState(null);
  const [editando, setEditando] = useState(null);
  const [form, setForm]         = useState({ nome: "", email: "" });
  const [modoForm, setModoForm] = useState(false);
  const [salvando, setSalvando] = useState(false);

  const carregar = () => {
    setLoading(true);
    fetchHeads().then(setLista).catch((e) => setErro(e.message)).finally(() => setLoading(false));
  };
  useEffect(carregar, []);

  const iniciarNovo  = () => { setEditando(null); setForm({ nome: "", email: "" }); setModoForm(true); };
  const iniciarEdicao = (h) => { setEditando(h); setForm({ nome: h.nome, email: h.email || "" }); setModoForm(false); };
  const cancelar     = () => { setEditando(null); setModoForm(false); setErro(null); };

  const guardar = async () => {
    if (!form.nome.trim()) { setErro("O nome é obrigatório."); return; }
    setSalvando(true); setErro(null);
    try {
      const payload = { nome: form.nome.trim(), email: form.email.trim() || null };
      modoForm ? await createHead(payload) : await updateHead(editando.id, payload);
      cancelar(); carregar();
    } catch (e) { setErro(e.message); }
    finally { setSalvando(false); }
  };

  const remover = async (h) => {
    if (!window.confirm(`Remover "${h.nome}"? Os planners associados ficarão sem Head.`)) return;
    await deleteHead(h.id); carregar();
  };

  return (
    <div>
      <div style={s.header}>
        <h2 style={s.titulo}>Heads</h2>
        <button style={s.btnNovo} onClick={iniciarNovo}>+ Nova Head</button>
      </div>

      {erro && <div style={s.erro}>{erro}</div>}

      {(modoForm || editando) && (
        <div style={s.formCard}>
          <h3 style={s.formTitulo}>{modoForm ? "Nova Head" : `Editar: ${editando.nome}`}</h3>
          <div style={s.formGrid}>
            <div style={s.formGrupo}>
              <label style={s.label}>Nome *</label>
              <input style={s.input} value={form.nome}
                onChange={(e) => setForm({ ...form, nome: e.target.value })} placeholder="Nome completo" />
            </div>
            <div style={s.formGrupo}>
              <label style={s.label}>Email</label>
              <input style={s.input} value={form.email} type="email"
                onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="email@exemplo.com" />
            </div>
          </div>
          <div style={s.formActions}>
            <button style={s.btnGuardar} onClick={guardar} disabled={salvando}>
              {salvando ? "A guardar…" : "Guardar"}
            </button>
            <button style={s.btnCancelar} onClick={cancelar}>Cancelar</button>
          </div>
        </div>
      )}

      {loading ? <p style={s.loading}>A carregar…</p>
       : lista.length === 0 ? <p style={s.semDados}>Nenhuma Head criada ainda.</p>
       : (
        <table style={s.tabela}>
          <thead><tr>
            <th style={s.th}>Nome</th>
            <th style={s.th}>Email</th>
            <th style={{ ...s.th, width: 140 }}>Ações</th>
          </tr></thead>
          <tbody>
            {lista.map((h) => (
              <tr key={h.id} style={editando?.id === h.id ? s.trEditando : s.tr}>
                <td style={s.td}>{h.nome}</td>
                <td style={s.td}>{h.email || "—"}</td>
                <td style={s.td}>
                  <div style={s.acoes}>
                    <button style={s.btnEditar} onClick={() => iniciarEdicao(h)}>Editar</button>
                    <button style={s.btnRemover} onClick={() => remover(h)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const s = {
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 },
  titulo: { fontSize: 16, fontWeight: 600, margin: 0, color: "#1e293b" },
  btnNovo: { padding: "8px 16px", background: "#6366f1", color: "#fff", border: "none", borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: "pointer" },
  formCard: { background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: 8, padding: 20, marginBottom: 20 },
  formTitulo: { fontSize: 14, fontWeight: 600, margin: "0 0 16px", color: "#374151" },
  formGrid: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 },
  formGrupo: { display: "flex", flexDirection: "column", gap: 4 },
  label: { fontSize: 12, fontWeight: 600, color: "#475569" },
  input: { padding: "8px 12px", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 13 },
  formActions: { display: "flex", gap: 8 },
  btnGuardar: { padding: "8px 20px", background: "#22c55e", color: "#fff", border: "none", borderRadius: 6, fontSize: 13, fontWeight: 600, cursor: "pointer" },
  btnCancelar: { padding: "8px 16px", background: "none", color: "#64748b", border: "1px solid #cbd5e1", borderRadius: 6, fontSize: 13, cursor: "pointer" },
  tabela: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: { textAlign: "left", padding: "8px 12px", backgroundColor: "#f8fafc", fontWeight: 600, borderBottom: "2px solid #e2e8f0", color: "#475569" },
  tr: { borderBottom: "1px solid #f1f5f9" },
  trEditando: { borderBottom: "1px solid #f1f5f9", backgroundColor: "#fefce8" },
  td: { padding: "10px 12px", color: "#374151" },
  acoes: { display: "flex", gap: 6 },
  btnEditar: { padding: "4px 12px", background: "#e0e7ff", color: "#4338ca", border: "none", borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: "pointer" },
  btnRemover: { padding: "4px 12px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: "pointer" },
  semDados: { color: "#94a3b8", fontSize: 14 },
  loading: { color: "#64748b", fontSize: 14 },
  erro: { background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 6, padding: 12, color: "#dc2626", marginBottom: 16, fontSize: 13 },
};
